import { useQueries } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';

import GroupFaqsPage from '../components/pages/faqs/group';
import { DETAILED_PRICES, SHIPPING_LOCATION } from '../static/cookies';
import { isGlobalUser } from '../utils/is-global-user';
import { isUKuser } from '../utils/is-uk-user';
import { isUSuser } from '../utils/is-us-user';
import getFaqs from '../utils/react-query/query-options/get-faqs';
import getGroups from '../utils/react-query/query-options/get-groups';

const useData = () => {
  const {
    locale,
    query: { group = '' },
    asPath,
  } = useRouter();

  const hash = asPath.includes('#') ? asPath.split('#')[1] : undefined;
  const queries = useMemo(
    () => ({
      queries: [getFaqs({ locale, slug: group })].map(([key, fn]) => ({
        queryKey: key,
        queryFn: fn,
      })),
    }),
    [locale, group]
  );

  const [{ data: faqsOfGroup }] = useQueries(queries);

  return {
    faqsOfGroup,
    hash,
  };
};

export default function Faqs() {
  const data = useData();
  return (
    <main>
      <GroupFaqsPage {...data} />
    </main>
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  locale = 'en',
  query: { group },
  req,
  res,
}) => {
  isUSuser(req, res);
  isUKuser(req, res);
  isGlobalUser(req, res);

  const { default: getGenericClient } = await import('../server/client');
  const genericClient = getGenericClient();

  try {
    await Promise.all([
      genericClient.fetchQuery(...getFaqs({ locale, slug: group }, req)),
    ]);

    const { default: retrieveStateAndClear } = await import(
      '../utils/retrieve-state-and-clear'
    );

    return {
      props: {
        dehydratedState: retrieveStateAndClear(genericClient),
        shippingLocation: parseInt(req.cookies[SHIPPING_LOCATION], 10),
        detailPrices: req.cookies[DETAILED_PRICES] || null,
      },
    };
  } catch (e) {
    if (e.status === 404) {
      return { notFound: true };
    }

    console.log(e);
    throw e;
  }
};
